import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js'
import axios from 'axios'
import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import DivBottom from '../userNotAuth/components/divBottom'
import { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

export default function PaypalButton() {
    const initialOptions = {
        "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID, // Lo stesso del backend
        currency: "EUR",
        intent: "capture",
    }

    const navigate = useNavigate()
    const [importo, setImporto] = useState({ importo: '', orderID: '' })
    const divDettagli = useRef()
    const divSuccess = useRef()

    const createOrder = async () => {
        // Chiamata al tuo backend Node.js per generare l'ordine su PayPal
        try {
            const response = await axios.post(`/api/orders/${importo.importo}`, {}, {
                headers: { 'Content-Type': 'application/json' },
            })
            // console.log("response:", response.data)

            // Verifichiamo che l'ID esista prima di passarlo a PayPal
            if (response.data && response.data.id) {
                return response.data.id; // Ritorna la stringa pura dell'ID ordine
            } else {
                throw new Error("L'ID dell'ordine manca nella risposta del server.")
            }
        } catch (error) {
            console.error("Errore durante createOrder nel frontend:", error)
        }
    }
    const onApprove = async (data) => {
        // Chiamata al tuo backend Node.js per confermare la cattura dei fondi
        const response = await axios.post(`/api/orders/${data.orderID}/capture`, {
            headers: { 'Content-Type': 'application/json' },
        })
        if (response.data.status === 'COMPLETED') {//pagamento success
            divSuccess.current.style.top = '0'
            // Reindirizza l'utente o aggiorna lo stato dell'app
        } else {
            alert('Errore durante il pagamento.')
        }
    }
    const handleChange = (e) => {
        const { value } = e.target
        const xd = document.getElementById('importo')
        if (/^[0-9.]+$/.test(value) === false) {
            xd.value = value.replace(/[^0-9.]/g, ''); return
        }
        setImporto({ ...importo, importo: value })
    }
    const paga = (e) => {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
        divDettagli.current.style.top = '0'; document.body.style.overflow = 'hidden'
    }
    return (<>
        {localStorage.getItem('email') !== 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <p style={{margin: '1.2em 0 0 20px', fontSize: 'xxx-large', cursor: 'pointer'}} onClick={()=>{navigate('/')}}>
          ⨞
        </p>
        <div style={{ border: '1px solid cornflowerblue', margin: '5em auto', padding: '30px', width: '80%', borderRadius: '10px' }}>
            <form style={{ marginTop: '1em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '20px' }} onSubmit={paga}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <label><b>IMPORTO:</b> </label>
                    <input className='ms-2'
                        id="importo"
                        placeholder='€'
                        name="cifra"
                        type='text'
                        onChange={(handleChange)}
                        required
                    />
                </div>
                <button type="submit" className='btn btn-primary mt-5'>Vai al pagamento</button>
            </form>
        </div>
        <button className='btn btn-secondary ms-4' onClick={()=>{navigate('/')}}>Indietro</button>

        {/* -------------------- BANNER PAYPAL ------------------ */}
        <div className='visualDettagli' ref={divDettagli}>
            <img src={require("../userNotAuth/image/icons8-chiudi-macos-32.png")} alt='' width={45} style={{ float: 'right', cursor: 'pointer' }}
                onClick={() => { divDettagli.current.style.top = '120%'; document.body.style.overflow = 'scroll' }} />
            <h3 className='mt-5'>IMPORTO: € {importo.importo}</h3>
            <PayPalScriptProvider options={initialOptions}>
                <div style={{
                    marginTop: '5em',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    padding: '20px 20px'
                }}>
                    <div style={{ width: '100%', maxWidth: '500px' }}>
                        <PayPalButtons
                            createOrder={createOrder}
                            onApprove={onApprove}
                            style={{ layout: "vertical" }}
                        />
                    </div>
                </div>
            </PayPalScriptProvider>
        </div>

        {/* ----------------- BANNER AVVENUTO PAGAMENTO ------------------- */}
        <div className='visualDettagli' ref={divSuccess}>
            <img src={require("../userNotAuth/image/icons8-chiudi-macos-32.png")} alt='' width={45} style={{ float: 'right', cursor: 'pointer' }}
                onClick={() => { document.body.style.overflow = "auto"; navigate('/') }} />
            <h1 className='text-center mt-5'>Pagamento avvenuto con successo ✅</h1>
            <p style={{marginTop: '5em', fontSize: 'large'}}>Il tuo pagamento di {importo.importo} € è andato a buon fine. Grazie per il suo acquisto.<br />
                ID ordine: {importo.orderID}
            </p><hr />
            <div>
                <button className='btn btn-secondary mt-5' onClick={() => { document.body.style.overflow = "auto"; navigate('/') }}>Indietro</button>
            </div>
        </div>
        <DivBottom />
    </>
    )
}
